var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"items":_vm.statusOptions,"item-text":"value","item-value":"value","label":_vm.label},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-list-item',_vm._g(_vm._b({},'v-list-item',attrs,false),on),[_c('v-chip',{attrs:{"small":"","color":item.colour,"dark":""}},[_vm._v(_vm._s(item.value))])],1)]}},{key:"selection",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"small":"","color":item.colour,"dark":""}},[_vm._v(_vm._s(item.value))])]}}]),model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }